import React from "react";

const BondCoinModeTabs = ({ modes, modeId, onChange }) => (
  <div className="bcoin-mode-tabs" role="tablist" aria-label="Bond Coin modes">
    {modes.map((mode) => {
      const Icon = mode.Icon;
      const active = mode.id === modeId;
      return (
        <button
          key={mode.id}
          type="button"
          role="tab"
          aria-selected={active}
          className={`bcoin-mode-tab${active ? " active" : ""}`}
          onClick={() => onChange(mode.id)}
        >
          <Icon size={14} strokeWidth={2.25} aria-hidden />
          <span>{mode.short}</span>
        </button>
      );
    })}
  </div>
);

export default BondCoinModeTabs;
